// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"59a523b0","239":"18f129fa","453":"acd6d51c","732":"bd42d0e0","952":"158798cb"}[chunkId] + ".chunk.js";
};